export { default as activityAndGeneralStats } from "./activityAndGeneralStatsReducer"
export { default as employeeEngagement } from "./employeeEngagementReducer"
export { default as intelAndInsights } from "./intelAndInsightsReducer"
export { default as peopleBalanceSheet } from "./peopleBalanceSheetReducer"
export { default as performanceAndProgression } from "./performanceAndProgressionReducer"
export { default as customReport } from "./customReportReducer"



// WEBPACK FOOTER //
// ./src/state/reducers/dashboards/index.js